// 新增关键字
import fetch from '@/plugin/axios'

// 获取产品列表
export function getOrderList (data) {
  return fetch({
    url: '/api/order/service-order/list',
    method: 'Post',
    data: data
  })
}

export function confirm (data) {
  return fetch({
    url: '/api/order/service-order/confirm',
    method: 'Put',
    data: data
  })
}
export function addRemark (id, remark) {
  return fetch({
    url: `/api/order/service-order/remark`,
    method: 'Put',
    data: { 'id': id, 'remark': remark }
  })
}

export function balanceOrderList (data) {
  return fetch({
    url: '/api/order/balance-order-log/list',
    method: 'Post',
    data: data
  })
}

export function balanceOrderConfirm (id) {
  return fetch({
    url: '/api/order/balance-order-log/confirm/' + id,
    method: 'Post'
  })
}

export function addBalanceOrderLog (data) {
  return fetch({
    url: '/api/order/balance-order-log/add',
    method: 'Post',
    data: data
  })
}
